// leggins-bota-campana.js — vanilla JS, sin dependencias
// window.MI_CONFIG: reservado para configuracion futura de esta seccion (no usado por apps externas).
// window.CHECKOUT_APP: reservado/documentado por compatibilidad con la app de COD (Releasit la define; este script no la sobreescribe).
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('.lbc-root').forEach(initSection);
  });

  function initSection(root) {
    // Fade-in de bloques de beneficios al entrar en viewport
    var fadeEls = root.querySelectorAll('.lbc-fade');
    if ('IntersectionObserver' in window && fadeEls.length) {
      var fadeObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('lbc-visible');
            fadeObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      fadeEls.forEach(function (el) { fadeObs.observe(el); });
    } else {
      fadeEls.forEach(function (el) { el.classList.add('lbc-visible'); });
    }

    // Barra sticky: aparece al pasar la buybox
    var sticky = root.querySelector('.lbc-sticky');
    var buybox = root.querySelector('.lbc-buybox');
    if (sticky && buybox && 'IntersectionObserver' in window) {
      var stickyObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('lbc-show', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      stickyObs.observe(buybox);
    }

    // Scroll suave hacia el formulario COD
    root.querySelectorAll('[data-lbc-scroll-to]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = root.querySelector(btn.getAttribute('data-lbc-scroll-to'));
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }
})();
